import { render, staticRenderFns } from "./RecognitionList.vue?vue&type=template&id=1a2f4fbd"
import script from "./RecognitionList.vue?vue&type=script&lang=js"
export * from "./RecognitionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports